import { render, staticRenderFns } from "./MessageListAvatar.vue?vue&type=template&id=482f7543&functional=true"
import script from "./MessageListAvatar.vue?vue&type=script&lang=js"
export * from "./MessageListAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports